import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings';
import { AzureFileStorageLinkedService } from 'app/model/linkedservice/azure-file-storage.linkedservice';

@Metamodel.model({
    name: 'AzureFileStorageWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureFileStorageLinkedService)
    }
})

export class AzureFileStorageStoreWriteSettings extends StoreWriteSettings {
}
